<template>
  <teleport to="body">
    <div
      v-if="openInstruction"
      class="flex flex-col bg-white fixed top-0 bottom-0 left-0 right-0 w-full h-svh z-10 px-8 py-4"
    >
      <div class="flex justify-center grow">
        <div class="absolute top-3 right-3" @click="closeInstruction">
          <img src="../assets/icons/cross.svg" />
        </div>
        <h1 class="text-2xl text-[#00AEEF] font-bold my-9">
          {{ $t('instruction.popup.header') }}
        </h1>
      </div>
      <div class="flex flex-col grow-0 gap-6 overflow-y-auto">
        <div>
          <h2 class="text-center text-base text-[#222222] font-bold mb-[6px]">
            {{ $t('instruction.popup.title') }}
          </h2>
          <p class="text-base text-black text-justify mb-2">
            {{ $t('instruction.popup.content') }}
          </p>
          <img
            :src="isHybrid ? images.qr_hybrid : images.qr"
            alt=""
            class="w-full max-w-[300px] m-auto relative block rounded-lg"
          />
        </div>
        <div class="steps">
          <h2 class="text-center text-base text-[#222222] font-bold mb-[6px]">
            {{ $t('instruction.popup.steps-and-tips.title') }}
          </h2>
          <img
            :src="isHybrid ? images.one_hybrid : images.one"
            alt=""
            class="w-full max-w-[300px] m-auto relative block rounded-lg"
          />
          <ul class="text-base text-black text-justify pl-5 my-2">
            <li>{{ $t('instruction.popup.steps-and-tips.list.one') }}</li>
            <li>{{ $t('instruction.popup.steps-and-tips.list.two') }}</li>
          </ul>
          <img
            :src="isHybrid ? images.two_hybrid : images.two"
            alt=""
            class="w-full max-w-[300px] m-auto relative block rounded-lg"
          />
          <ul class="text-base text-black text-justify pl-5 my-2">
            <li>{{ $t('instruction.popup.steps-and-tips.list.three') }}</li>
            <li>{{ $t('instruction.popup.steps-and-tips.list.four') }}</li>
          </ul>
          <img
            :src="isHybrid ? images.three_hybrid : images.three"
            alt=""
            class="w-full max-w-[300px] m-auto relative block rounded-lg"
          />
          <ul class="text-base text-black text-justify pl-5 my-2">
            <li>{{ $t('instruction.popup.steps-and-tips.list.five') }}</li>
            <li>{{ $t('instruction.popup.steps-and-tips.list.six') }}</li>
          </ul>
          <img
            :src="isHybrid ? images.four_hybrid : images.four"
            alt=""
            class="w-full max-w-[300px] m-auto relative block rounded-lg"
          />
          <ul class="text-base text-black text-justify pl-5 my-2">
            <li>{{ $t('instruction.popup.steps-and-tips.list.seven') }}</li>
          </ul>
        </div>
        <div class="flex flex-col justify-center items-center gap-5 mb-10">
          <ButtonComponent
            :onClick="openCamera"
            buttonName="instruction.popup.take-photo"
          />
          <ButtonComponent
            :onClick="closeInstruction"
            buttonClass="text-[#00AEEF] text-sm underline"
            buttonName="instruction.popup.go-back"
          />
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup>
import qr from '@/assets/images/qr.png'
import steps from '@/assets/scan-instruction/full-steps.gif'
import one_hybrid from '@/assets/scan-instruction/hybrid_step_1.gif'
import two_hybrid from '@/assets/scan-instruction/hybrid_step_2.gif'
import three_hybrid from '@/assets/scan-instruction/hybrid_step_3.gif'
import four_hybrid from '@/assets/scan-instruction/hybrid_step_4.gif'
import one from '@/assets/scan-instruction/step-1.gif'
import two from '@/assets/scan-instruction/step-2.gif'
import three from '@/assets/scan-instruction/step-3.gif'
import four from '@/assets/scan-instruction/step-4.gif'
import qr_hybrid from '../assets/images/hybrid_qr.png'

import { events } from '@/utils/events'
import ButtonComponent from './ButtonComponent.vue'

defineProps({
  openInstruction: {
    type: Boolean,
    default: true
  },
  isHybrid: Boolean
})

const emits = defineEmits(['close'])

const images = {
  steps,
  one,
  two,
  three,
  four,
  qr,
  one_hybrid,
  two_hybrid,
  three_hybrid,
  four_hybrid,
  qr_hybrid
}

const closeInstruction = () => {
  emits('close')
}

const openCamera = () => {
  closeInstruction()
  events.value.triggerTakePicture = true
}
</script>
